window.$ = window.jQuery = require('jquery');
require('./lib/featherlight.min.js');
require('./lib/hammer.min.js');

// TODO if they want to only animate (fade) the one top circle
// Use 'clip-path' on the inner circle, and change the value as it rotates around
// The top would be something like: clip-path: circle(280px at 50% 0); - I think.
// As the circle rotates, the clip-path position (50% 0) needs to change
// It could even have an animation where it "opens up"

export function closedLoop() {

  $(document).ready(function(){

    const $closedLoopCircle = $('.clc');

    if ($closedLoopCircle.length) {

      const $closedLoopCircles = $closedLoopCircle.find('li');
      const $closedLoopButton = $('.B27 .B27-button');

      $closedLoopButton.on('click', function(e) {
        e.preventDefault();
        $.featherlight('#closed-loop-modal', {
          variant: 'closed-loop',
          closeIcon: '<span class=\'svg js-svg-fallback svg-inline icon-icon_x\' data-filename=\'icon_x\'><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="#AF1C2E" fill-rule="evenodd" d="M9 7.5l-3-3 3-3L7.5 0l-3 3-3-3L0 1.5l3 3-3 3L1.5 9l3-3 3 3z"/></svg></span> <span class="label">Close</span>',
          afterContent: function() {
            togglePhoto();
            setIndex(0);
            setupSwipe();
          }
        });
      });

      $closedLoopCircles.on('click', function (e) {
        e.preventDefault();
        let index = $(this).index();
        let newRotationVal = -72 * index;
        $.featherlight('#closed-loop-modal', {
          variant: 'closed-loop',
          closeIcon: '<span class=\'svg js-svg-fallback svg-inline icon-icon_x\' data-filename=\'icon_x\'><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="#AF1C2E" fill-rule="evenodd" d="M9 7.5l-3-3 3-3L7.5 0l-3 3-3-3L0 1.5l3 3-3 3L1.5 9l3-3 3 3z"/></svg></span> <span class="label">Close</span>',
          afterContent: function() {

            // After Featherlight is loaded and content is set
            togglePhoto();

            let $closedLoopGraphic = $('.featherlight-content .clm__graphic');
            $closedLoopGraphic.get(0).style.transform = "rotate("+newRotationVal+"deg)";
            setPagination(index);
            setCaption(index);
            setIndex(index);
            setupSwipe();

          }
        });
      });

      function moveWheel(back) {

        togglePhoto();

        let $pagination = $('.featherlight-content .clm__pagination');
        let $navItems = $pagination.find('li');
        let currentIndex = $navItems.filter('.active').index();
        let paginationLength = $navItems.length;
        let nextIndex = currentIndex + 1;
        if (!back && (currentIndex == paginationLength - 1)) {
          nextIndex = 0;
        }
        if (back) {
          nextIndex = currentIndex - 1;
        }
        if (back && (currentIndex == 0)) {
          nextIndex = paginationLength - 1;
        }

        setPagination(nextIndex);
        setCaption(nextIndex);

        // Update Wheel location
        let closedLoopGraphic = document.querySelector('.featherlight-content .clm__graphic');

        let value = closedLoopGraphic.style.transform;
        let angle = 0;
        if (value) {
          let values = value.split('(')[1].split('deg')[0].split(')');
          let a = values[0];
          let b = values[1];
          let c = values[2];
          let d = values[3];
          angle = parseInt(a);
        }

        // let angle = Math.round(Math.atan2(b, a) * (180/Math.PI));
        let newAngle = angle - 72;
        if (back) {
          newAngle = angle + 72;
        }
        closedLoopGraphic.style.transform = "rotate(" + newAngle + "deg)";

        setTimeout(setIndex(nextIndex), 1000);

      }

      function setPagination(index) {
        let $pagination = $('.featherlight-content .clm__pagination');
        let $navItems = $pagination.find('li');
        // Update pagination navigation
        $navItems.removeClass('active');
        $navItems.eq(index).addClass('active');
      }

      function setCaption(index) {
        let $captions = $('.featherlight-content .clm__caption');
        $captions.removeClass('active');
        $captions.eq(index).addClass('active');
      }

      function setIndex(index) {
        let $graphic = $('.featherlight-content .clm__graphic');
        $graphic.find('.clm__graphic--photo').attr('data-position', index);
      }

      function setupSwipe() {
        let closedLoopGraphic = document.querySelector('.featherlight-content .clm__graphic');
        let hammertime = new Hammer(closedLoopGraphic, {

        });
        hammertime.on('swipe', function(ev){
          if (ev.direction == 2) {
            moveWheel();
          } else if (ev.direction == 4) {
            moveWheel(true);
          }
        });
      }

      function togglePhoto() {
        let $closedLoopGraphic = $('.featherlight-content .clm__graphic');
        $closedLoopGraphic.addClass('animate');
        setTimeout(function(){
          $closedLoopGraphic.addClass('animated');
          $closedLoopGraphic.removeClass('animate');
        }, 1500);
      }

      $('body').on('click', '.featherlight-content .clm__pagination--prev', function(e){
        moveWheel(true);
      });
      $('body').on('click', '.featherlight-content .clm__pagination--next', function(e){
        moveWheel();
      });
      $('body').on('click', '.clm__pagination--list li', function(e){
        let index = $(this).index();
        let newRotationVal = -72 * index;
        let $closedLoopGraphic = $('.featherlight-content .clm__graphic');
        $closedLoopGraphic.get(0).style.transform = "rotate("+newRotationVal+"deg)";
        setPagination(index);
        setCaption(index);
        setIndex(index);
      });

    }

  });

}


// WEBPACK FOOTER //
// ./resources/js/closedLoop.js